import React from 'react';

const LinearCarousel = ({ images, style }) => {
  return (
    <div className="overflow-hidden w-full relative group">
      <div className="flex animate-marquee whitespace-nowrap items-center gap-3">
        {images.concat(images).map((image, index) => (
          <div key={index} className="flex-shrink-0 p-4">
            <img
              src={image}
              alt={`Sponsor ${index + 1}`}
             
              className={`   object-contain ${style}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LinearCarousel;